import { NavLink } from 'react-router-dom';

import { AuthStatus } from '@/authentication/auth-status';
import { useGame } from '@/hooks/useGame';
import logo from '@/assets/light-nacon.png';
import { sandboxCode } from '@/lib/utils';
import type { DashboardItem } from '@/models/dashboardItem';

import {
  Sidebar as ShadSidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarHeader,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarMenuSub,
  SidebarMenuSubButton,
  SidebarMenuSubItem,
} from '../ui/sidebar';

interface ProSidebarProps {
  items?: DashboardItem[];
}

const MenuItemWithChildren = ({ item }: { item: DashboardItem }) => {
  return (
    <SidebarMenuItem>
      <SidebarMenuButton asChild>
        <NavLink end to={item.link}>
          {item.icon} {item.label}
        </NavLink>
      </SidebarMenuButton>
      <SidebarMenuSub>
        {item.items?.map((_item) => (
          <SidebarMenuSubItem key={_item.label}>
            <SidebarMenuSubButton asChild>
              <NavLink
                end
                to={`${item.link}/${_item.link}`}
                className={({ isActive }) => (isActive ? 'active' : '')}
              >
                {_item.icon} {_item.label}
              </NavLink>
            </SidebarMenuSubButton>
          </SidebarMenuSubItem>
        ))}
      </SidebarMenuSub>
    </SidebarMenuItem>
  );
};

export const AppSidebar = ({ items = [] }: ProSidebarProps) => {
  const game = useGame();
  return (
    <ShadSidebar side="left">
      <SidebarHeader>
        <SidebarMenu>
          <SidebarMenuItem>
            <SidebarMenuButton asChild>
              <a
                href={`/game/${game.game_code}/${sandboxCode(game.game_code)}/players`}
                className="p-6 px-4"
              >
                <img
                  className="watermark"
                  src={logo}
                  width={24}
                  height={24}
                  alt="Nacon Live"
                />
                <span className="text-base">Nacon Live</span>
              </a>
            </SidebarMenuButton>
          </SidebarMenuItem>
        </SidebarMenu>
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          {items.map((item) => (
            <MenuItemWithChildren key={item.label} item={item} />
          ))}
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter>
        <AuthStatus />
      </SidebarFooter>
    </ShadSidebar>
  );
};
